import { formatLocaleDate, formatLocaleDateTime } from "@/utils/formatUtils";
import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { UserBase } from "../../../modules/user/types";

interface ItemProps {
  createdAt?: string;
  createdBy?: UserBase;
  updatedAt?: string;
  verifiedAt?: string;
  verifiedBy?: UserBase;
  lastContractDate?: string;
}

interface Props {
  item?: ItemProps;
  className?: string;
  style?: CSSProperties;
}

export const ItemCreatedUpdatedInfoView = ({ item, className, style }: Props) => {
  const { t } = useTranslation();

  return item ? (
    <div className={"sub-header-info " + (className ? className : "")} style={style}>
      {item.createdAt && (
        <>
          <span>{t("common.createdAt")}:</span> {formatLocaleDateTime(item.createdAt)}
        </>
      )}
      {item.createdBy && ` - ${item.createdBy?.name}`}

      {item.updatedAt && (
        <>
          {" "}
          | <span>{t("common.updatedAt")}:</span> {formatLocaleDateTime(item.updatedAt)}
        </>
      )}

      {item.verifiedAt && (
        <>
          {" "}
          | <span>{t("common.verifiedAt")}:</span> {formatLocaleDateTime(item.verifiedAt)}
        </>
      )}
      {item.verifiedBy && ` - ${item.verifiedBy?.name}`}

      {item.lastContractDate && (
        <>
          {" "}
          | <span>{t("client.attrs.lastContractDate")}:</span> {formatLocaleDate(item.lastContractDate)}
        </>
      )}
    </div>
  ) : null;
};
